export const HubSpotForStartupsTypeDecorator = {
  url() {
    return `signup-hubspot/hubspot-for-startups`;
  },

  query() {
    return {};
  }

};